import { RootState } from 'state/store';

export const selectedVehicle = (state: RootState) =>
    state.vehicles.vehicleList[state.vehicles.selectedVehicleIndex];

export const vehicleByPolicy = (state: RootState, policyReference: string) =>
    state.vehicles.vehicleList.find((p) =>
        p.policies.some((r) => r.reference === policyReference)
    );

export const selectMissedPaymentDetailsByPolicy = (
    state: RootState,
    policyReference: string
) =>
    state.vehicles.vehicleList
        .flatMap((v) => v.policies)
        .find((p) => p.reference === policyReference)?.missedPaymentDetails;
